import { useEffect, useState } from "react";
import { CHANGELOGS } from "../../changelog-loader";

const STORAGE_KEY = "lastSeenVersion";

export function useChangelogDialog() {
  const [content, setContent] = useState<string | null>(null);
  const appVersion = process.env.REACT_APP_VERSION ?? "unknown";

  useEffect(() => {
    const lastSeen = localStorage.getItem(STORAGE_KEY) ?? "0.0.0";

    const unseen = Object.keys(CHANGELOGS)
      .filter(v => isNewer(v, lastSeen))
      .sort((a, b) => (isNewer(a, b) ? 1 : -1));
    
    if (unseen.length) {
      const merged = unseen
        .map(v => CHANGELOGS[v])
        .join('\n\n---\n\n');
      setContent(merged);
    }
  }, []);

  const closeDialog = () => {
    console.log('close changelog dialog');
    localStorage.setItem(STORAGE_KEY, appVersion);
    setContent(null);
  };

  return { content, closeDialog };
}

export function isNewer(a: string, b: string) {
  const pa = a.split(".").map(Number);
  const pb = b.split(".").map(Number);

  for (let i = 0; i < 3; i++) {
    if (pa[i] > pb[i]) return true;
    if (pa[i] < pb[i]) return false;
  }
  return false;
}
